import { render } from "./AddEditEventNav.vue?vue&type=template&id=2af829f9&scoped=true"
import script from "./AddEditEventNav.vue?vue&type=script&lang=js"
export * from "./AddEditEventNav.vue?vue&type=script&lang=js"

import "./AddEditEventNav.vue?vue&type=style&index=0&id=2af829f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af829f9"]])

export default __exports__